import React from 'react'

const FlyerInBookshelf = () => {
  return (
    <img style={{position: "relative", height: "100%", pointerEvents: "none", userSelect: "none"}} src="/svgs/flyer_in_bookshelf.svg" alt="flyer_in_bookshelf"/>
  )
}

export default FlyerInBookshelf